// extracted by mini-css-extract-plugin
module.exports = {"gridIcon":"styles__gridIcon___2MUuX","menu":"styles__menu___39DXe","menuItem":"styles__menuItem___1eAMa","menuItemIcon":"styles__menuItemIcon___1A0FI"};